<template>
  <button
    tabindex="0"
    :class="classes"
    :disabled="disabled"
    @keyup.tab="keyupTab"
    @blur="onblur">
    <slot />
  </button>
</template>

<script>
const types = ['full', 'wired']
const background = ['white', 'black', 'transparent']

export default {
  name: 'WptvButton',
  props: {
    background: { // background où le bouton est mis
      type: String,
      default: 'white',
      validator: (value) => background.includes(value)
    },
    type: {
      type: String,
      default: 'full',
      validator: (value) => types.includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isActive: Boolean
  },
  data () {
    return {
      /** {boolean} attr pour respecter le style pour l'accessibilité
            true quand le bouton est focus depuis tab ou shift+Tab
            false lorsque blur survient
        */
      isTabbed: false
    }
  },
  computed: {
    classes () {
      const classes = ['btn']
      if (this.type === 'wired') {
        classes.push('btn-secondary')
      }
      if (this.type === 'full') {
        classes.push('btn-primary')
      }
      if (this.background === 'black') {
        classes.push('btn-inverse')
      }
      return classes
    }
  },
  methods: {
    keyupTab () {
      // The method is called on Tab and on shift+Tab
      this.isTabbed = true
    },
    onblur () {
      this.isTabbed = false
    }
  }
}
</script>
